import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import VueI18n from "vue-i18n";
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

//in progress of moving to external file
import routes_external from './routes';

import VueTippy, { TippyComponent } from "vue-tippy";

//output data for dev purposes
if (process.env.NODE_ENV == "development") console.log(process.env);

// console.log('isfull', ['full', 'full-mac'].includes(process.env.VUE_APP_MODE))

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import tnved from "./components/fields/tnved";
import Cache from "js-cache";
import Navigation from "./components/navigation/navigation";

/**
 * Jonas, change dev_mode to true to switch on the dev mode on the localhost
 */
// Start browser without security (e.g. https://medium.com/@abfgrace/how-to-run-a-unsafe-chrome-browser-without-cors-cfe6492bf434)
// run in separate terminal
// npm i local-cors-proxy -g
// lcp --proxyUrl https://attistrade.kz --port 8081 --origin https://attistrade.kz --credentials
const devModeWithProxy = false;

const dev_mode =
process.env.VUE_APP_MODE == "atb-mac" ||
process.env.VUE_APP_MODE == "full-mac" ||
devModeWithProxy;

const cacheable = true;
const show_errors_in_log = true;

const is_bank = true; //if is_bank, than it hides all anneccessary

/**
 * fm1, packaging, rwb – left v-select-popup
 */

window.dev_mode = dev_mode;
window.is_bank = is_bank;

// window.addEventListener('beforeunload', ()=>{
//   if(store.state.auth){
//     axios.get(window.base + '/account/DataWindow_Closing')
//   }
// })

// require("./assets/css/material-kit.css");
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue-search-select/dist/VueSearchSelect.css";
import "vue-select/dist/vue-select.css";
import "noty/src/noty.scss";
import "noty/src/themes/light.scss";
import "tippy.js/themes/light-border.css";
require("./assets/css/shards.css");
// require("./assets/css/shards-extra.css");
import _locale from 'element-ui/lib/locale/lang/en'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, { locale: _locale });

var $S = require("scriptjs");

/**
 * Adding Sentry error tracking for production versions
 */
if (!window.dev_mode && !show_errors_in_log) {
  Sentry.init({
    dsn: "https://33f5c17758d24de0896bc3f8a2ec01bc@o409443.ingest.sentry.io/5287249",
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

import _ from "lodash";
window.base = "https://dev.attistrade.kz";
if (dev_mode === false) window.base = "";

if (devModeWithProxy) {
  window.base = "http://localhost:8081/proxy";
}

window.token = "";

//function to get new token from backend on demand
window.is_token_loaded = {
  status: false,
};
window.updateToken = () => {
  // setTimeout(()=>{
  //   window.location.reload()
  // }, 1000)
  window.is_token_loaded.status = true;

  window.axios.get(window.base + "/account/RefreshToken").then((response) => {
    const regex =
      /name="__RequestVerificationToken" type="hidden" value="(.*)"/gm;
    let m;
    m = regex.exec(response.data);
    window.token = m[1];
    window.axios.defaults.headers.common["__RequestVerificationToken"] =
      window.token;
    console.log("🔒 Token updated");
    window.vue.$emit("token_updated");
    window.is_token_loaded.status = false;
  });
};

window.addEventListener("load", () => {
  // window.token = document.querySelector('input[name="__RequestVerificationToken"]').value
  // window.axios.defaults.headers.common["RequestVerificationToken"] = window.token;
  // window.axios.defaults.headers.common["__RequestVerificationToken"] = window.token;
  window.updateToken();
});

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require("jquery");

  window.Popper = require("popper.js").default;

  require("bootstrap");

  // require('bootstrap-datetimepicker-npm');
  require("bootstrap-datepicker/dist/locales/bootstrap-datepicker.zh-CN.min.js");
  require("bootstrap-datepicker/dist/locales/bootstrap-datepicker.ru.min.js");
  require("bootstrap-datepicker/dist/locales/bootstrap-datepicker.en-GB.min.js");

  function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.onload = callback;
    script.src = url;
    document.head.appendChild(script);
  }

  // Load jQuery, then SignalR, then hubs
  loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.4/jquery.js', () => {
    loadScript('https://cdnjs.cloudflare.com/ajax/libs/signalr.js/2.2.0/jquery.signalR.js', () => {
      loadScript('http://localhost:26640/signalr/hubs', () => {
      });
    });
  });
} catch (e) {
  console.error(e);
}
import "bootstrap-datepicker";
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.cache = new Cache();
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if (devModeWithProxy) {
  window.axios.defaults.withCredentials = true;
}

function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}
function isNumeric(str) {
  if (typeof str == "number") return true;
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(str) && !isNaN(parseFloat(str)) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
  ); // ...and ensure strings of whitespace fail
}

function filter(obj) {
  try {
    if (isNumeric(obj)) return obj;
    if (IsJsonString(obj)) {
      $.each(obj, function (key, value) {
        if (
          value === null ||
          ((typeof value === "string" || value instanceof String) &&
            value.trim() == "undefined")
        ) {
          obj[key] = "";
        } else if (
          Object.prototype.toString.call(value) === "[object Object]"
        ) {
          obj[key] = filter(value);
        } else if (_.isArray(value)) {
          try {
            $.each(value, function (k, v) {
              obj[key][k] = filter(v);
            });
          } catch (e) {
            console.error(e);
          }
        }
      });
    } else {
      $.each(obj, function (key, value) {
        if (
          value === null ||
          ((typeof value === "string" || value instanceof String) &&
            value.trim() == "undefined")
        ) {
          obj[key] = "";
        } else if (
          Object.prototype.toString.call(value) === "[object Object]"
        ) {
          obj[key] = filter(value);
        } else if (_.isArray(value)) {
          try {
            $.each(value, function (k, v) {
              obj[key][k] = filter(v);
            });
          } catch (e) {
            console.error(e);
          }
        }
      });
      return obj;
    }
  } catch (e) {
    return obj;
  }
}

// window.requesting_token = false
// window.is_logging_out = false

window.axios.interceptors.request.use(function (request) {
  // if(window.requesting_token){
  //   throw new axios.Cancel('Prevented multiple token refreshes');
  // }
  // if(window.is_logging_out){
  //   throw new axios.Cancel('Prevented multiple logouts');
  // }

  // if(request.url.includes('/account/RefreshToken')){
  //   window.requesting_token = true
  // }
  // if(request.url.includes('/logout')){
  //   window.is_logging_out = true
  // }
  if (request.method.toUpperCase() === "POST") {
    if (request.url !== "/account/SSOLogin") {
      if (typeof request.data === "object" && request.data) {
        if (request.data instanceof FormData) {
          request.data.append("__RequestVerificationToken", window.token || "");
        } else {
          request.data["__RequestVerificationToken"] = window.token || "";
        }
      } else if (typeof request.data === "string") {
        request.data = request.data + "&__RequestVerificationToken=" + (window.token || "");
      }
    }
  }
  return request;
});
// window.axios.interceptors.request.use(function(request){
// 	if(request.url.indexOf('?')>-1)
// 		request.url +='&token='+window.token
// 	else
// 		request.url +='?token='+window.token
// 	return request
// });
window.axios.interceptors.response.use(
  function (response) {
    // if(window.requesting_token && response.config.url.includes('/account/RefreshToken')){
    //   window.requesting_token = false
    // }
    // if(window.is_logging_out && response.config.url.includes('/logout')){
    //   window.is_logging_out = false
    // }
    if (dev_mode === false)
      if (response.data == "login first") {
        window.vue.$emit("logout");
      }
    filter(response.data);
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  },
);

// On request, return the cached version, if any
window.axios.interceptors.request.use(
  (request) => {
    // Only cache GET requests
    if (request.method === "get" && cacheable) {
      let url = request.url;

      // Append the params, I use jquery param but you can change to whatever you use
      if (request.params) url += "?" + $.param(request.params);

      const _cached = window.cache.get(url);

      if (_cached) {
        _cached.__fromCache = true;

        console.table(`📀 Served from cache:`, url, _cached);

        request.data = _cached;

        // Set the request adapter to send the cached response and prevent the request from actually running
        request.adapter = () => {
          return Promise.resolve({
            data: _cached,
            status: request.status,
            statusText: request.statusText,
            headers: request.headers,
            config: request,
            request: request,
          });
        };
      }
    }

    return request;
  },
  (error) => Promise.reject(error),
);

axios.interceptors.response.use(
  (response) => {
    // if you dont want to cache a specific url, send a param `__cache = false`
    const isCacheable =
      !response.config.params ||
      (response.config.params && response.config.params.__cache !== false);

    if (cacheable && isCacheable) {
      let url = response.config.url;

      if (response.config.params) url += "?" + $.param(response.config.params);

      if (/library|getFirmbybin|searchEgrul/i.test(url)) {
        if (!/openapi/i.test(url)) {
          if (response.config.method === "get") {
            console.info("💾 Stored to cache", url);
            // On get request, store the response in the cache
            window.cache.set(url, response.data, 60000);
          } else {
            // For post, put or delete, just delete the cached version of the url
            // e.g. posting to `/users` would delete the `/users` cache, so when you ask for users again you get the real version
            window.cache.del(response.config.url);
            // console.log(response.config.http)
            // also, when making a post,put or delete request to `/users/1`, would try to delete the `/users` for the same reason
            // const uri = url.replace(config.http.api.base_url, ''),
            // parentUri = /(.*)\/([a-z0-9\-]+)\/?$/ig.exec(uri);

            // if (parentUri)
            // window.cache.del(`${config.http.api.base_url}${parentUri[1]}`);

            // Delete similar url that just have query string diferences
            // Specially useful for things like Laravel's `with` param
            // e.g. `/users?with=permissions` will get cached but the post to `/users` wont remove it from the cache
            // so I look all the cached url's and try to match it without the querystrings
            const urls = Object.keys(window.cache.debug());

            for (const _url of urls) {
              if (_url.match(/^[^?]+/)[0] === response.config.url)
                window.cache.del(_url);
            }
          }
        } else {
          console.info("🚫 Оut of caching range", url);
        }
      } else {
        console.info("🚫 Оut of caching range", url);
      }
    }

    return response;
  },
  (error) => Promise.reject(error),
);

window.Noty = require("noty");

Number.prototype.toPhrase = function (
  c, // сумма прописью для чисел от 0 до 999 триллионов // можно передать параметр "валюта": RUB,USD,EUR (по умолчанию RUB)
) {
  console.log(c);
  var x = this.toFixed(2);
  if (x < 0 || x > 999999999999999.99) return false;

  var currency = "EUR";
  if (typeof c == "string") currency = c.trim().toUpperCase();
  if (currency == "") currency = "EUR";

  //   if (currency=='RUR') currency='RUB';
  //   if (currency!='RUB' && currency!='USD' && currency!='EUR')
  // return false;

  var groups = new Array();

  groups[0] = new Array();
  groups[1] = new Array();
  groups[2] = new Array();
  groups[3] = new Array();
  groups[4] = new Array();

  groups[9] = new Array();

  // рубли
  // по умолчанию
  groups[0][-1] = {
    RUB: "рублей",
    USD: "долларов США",
    EUR: "евро",
    currency: currency,
  };
  //исключения
  groups[0][1] = {
    RUB: "рубль",
    USD: "доллар США",
    EUR: "евро",
    currency: currency,
  };
  groups[0][2] = {
    RUB: "рубля",
    USD: "доллара США",
    EUR: "евро",
    currency: currency,
  };
  groups[0][3] = {
    RUB: "рубля",
    USD: "доллара США",
    EUR: "евро",
    currency: currency,
  };
  groups[0][4] = {
    RUB: "рубля",
    USD: "доллара США",
    EUR: "евро",
    currency: currency,
  };

  // тысячи
  // по умолчанию
  groups[1][-1] = "тысяч";
  //исключения
  groups[1][1] = "тысяча";
  groups[1][2] = "тысячи";
  groups[1][3] = "тысячи";
  groups[1][4] = "тысячи";

  // миллионы
  // по умолчанию
  groups[2][-1] = "миллионов";
  //исключения
  groups[2][1] = "миллион";
  groups[2][2] = "миллиона";
  groups[2][3] = "миллиона";
  groups[2][4] = "миллиона";

  // миллиарды
  // по умолчанию
  groups[3][-1] = "миллиардов";
  //исключения
  groups[3][1] = "миллиард";
  groups[3][2] = "миллиарда";
  groups[3][3] = "миллиарда";
  groups[3][4] = "миллиарда";

  // триллионы
  // по умолчанию
  groups[4][-1] = "триллионов";
  //исключения
  groups[4][1] = "триллион";
  groups[4][2] = "триллиона";
  groups[4][3] = "триллиона";
  groups[4][4] = "триллиона";

  // копейки
  // по умолчанию
  groups[9][-1] = {
    RUB: "копеек",
    USD: "центов",
    EUR: "центов",
    currency: "центов",
  };
  //исключения
  groups[9][1] = { RUB: "копейка", USD: "цент", EUR: "цент", currency: "цент" };
  groups[9][2] = {
    RUB: "копейки",
    USD: "цента",
    EUR: "цента",
    currency: "цента",
  };
  groups[9][3] = {
    RUB: "копейки",
    USD: "цента",
    EUR: "цента",
    currency: "цента",
  };
  groups[9][4] = {
    RUB: "копейки",
    USD: "цента",
    EUR: "цента",
    currency: "цента",
  };

  // цифры и числа
  // либо просто строка, либо 4 строки в хэше
  var names = new Array();
  names[1] = { 0: "один", 1: "одна", 2: "один", 3: "один", 4: "один" };
  names[2] = { 0: "два", 1: "две", 2: "два", 3: "два", 4: "два" };
  names[3] = "три";
  names[4] = "четыре";
  names[5] = "пять";
  names[6] = "шесть";
  names[7] = "семь";
  names[8] = "восемь";
  names[9] = "девять";
  names[10] = "десять";
  names[11] = "одиннадцать";
  names[12] = "двенадцать";
  names[13] = "тринадцать";
  names[14] = "четырнадцать";
  names[15] = "пятнадцать";
  names[16] = "шестнадцать";
  names[17] = "семнадцать";
  names[18] = "восемнадцать";
  names[19] = "девятнадцать";
  names[20] = "двадцать";
  names[30] = "тридцать";
  names[40] = "сорок";
  names[50] = "пятьдесят";
  names[60] = "шестьдесят";
  names[70] = "семьдесят";
  names[80] = "восемьдесят";
  names[90] = "девяносто";
  names[100] = "сто";
  names[200] = "двести";
  names[300] = "триста";
  names[400] = "четыреста";
  names[500] = "пятьсот";
  names[600] = "шестьсот";
  names[700] = "семьсот";
  names[800] = "восемьсот";
  names[900] = "девятьсот";

  var r = "";
  var i, j;

  var y = Math.floor(x);

  // если НЕ ноль рублей
  if (y > 0) {
    // выделим тройки с руб., тыс., миллионами, миллиардами и триллионами
    var t = new Array();

    for (i = 0; i <= 4; i++) {
      t[i] = y % 1000;
      y = Math.floor(y / 1000);
    }

    var d = new Array();

    // выделим в каждой тройке сотни, десятки и единицы
    for (i = 0; i <= 4; i++) {
      d[i] = new Array();
      d[i][0] = t[i] % 10; // единицы
      d[i][10] = (t[i] % 100) - d[i][0]; // десятки
      d[i][100] = t[i] - d[i][10] - d[i][0]; // сотни
      d[i][11] = t[i] % 100; // две правых цифры в виде числа
    }

    for (i = 4; i >= 0; i--) {
      if (t[i] > 0) {
        if (names[d[i][100]])
          r +=
            " " +
            (typeof names[d[i][100]] == "object"
              ? names[d[i][100]][i]
              : names[d[i][100]]);

        if (names[d[i][11]])
          r +=
            " " +
            (typeof names[d[i][11]] == "object"
              ? names[d[i][11]][i]
              : names[d[i][11]]);
        else {
          if (names[d[i][10]])
            r +=
              " " +
              (typeof names[d[i][10]] == "object"
                ? names[d[i][10]][i]
                : names[d[i][10]]);
          if (names[d[i][0]])
            r +=
              " " +
              (typeof names[d[i][0]] == "object"
                ? names[d[i][0]][i]
                : names[d[i][0]]);
        }

        if (names[d[i][11]])
          // если существует числительное
          j = d[i][11];
        else j = d[i][0];

        if (groups[i][j]) {
          if (i == 0) r += " " + groups[i][j][currency];
          else r += " " + groups[i][j];
        } else {
          if (i == 0) r += " " + groups[i][-1][currency];
          else r += " " + groups[i][-1];
        }
      }
    }

    if (t[0] == 0) r += " " + groups[0][-1][currency];
  } else r = "Ноль " + groups[0][-1][currency];

  y = ((x - Math.floor(x)) * 100).toFixed();
  if (y < 10) y = "0" + y;

  //   r=r.trimMiddle();
  r = r.substr(0, 1).toUpperCase() + r.substr(1);
  r += " " + y;

  y = y * 1;

  if (names[y])
    // если существует числительное
    j = y;
  else j = y % 10;

  if (groups[9][j]) r += " " + groups[9][j][currency];
  else r += " " + groups[9][-1][currency];

  return r;
};

function num_letters(k, d) {
  // целое число прописью, это основа
  var i = "",
    e = [
      [
        "",
        "тысяч",
        "миллион",
        "миллиард",
        "триллион",
        "квадриллион",
        "квинтиллион",
        "секстиллион",
        "септиллион",
        "октиллион",
        "нониллион",
        "дециллион",
      ],
      ["а", "и", ""],
      ["", "а", "ов"],
    ];
  if (typeof k == "object") k = k[0];

  if (k == "" || k == "0" || typeof k == "undefined" || isNaN(k))
    return " ноль"; // 0
  k = k.split(/(?=(?:\d{3})+$)/); // разбить число в массив с трёхзначными числами
  if (k[0].length == 1) k[0] = "00" + k[0];
  if (k[0].length == 2) k[0] = "0" + k[0];
  for (var j = k.length - 1; j >= 0; j--) {
    // соединить трёхзначные числа в одно число, добавив названия разрядов с окончаниями
    if (k[j] != "000") {
      i =
        (((d && j == k.length - 1) || j == k.length - 2) &&
          (k[j][2] == "1" || k[j][2] == "2")
          ? t(k[j], 1)
          : t(k[j])) +
        declOfNum(
          k[j],
          e[0][k.length - 1 - j],
          j == k.length - 2 ? e[1] : e[2],
        ) +
        i;
    }
  }
  function t(k, d) {
    // преобразовать трёхзначные числа
    var e = [
      [
        "",
        " один",
        " два",
        " три",
        " четыре",
        " пять",
        " шесть",
        " семь",
        " восемь",
        " девять",
      ],
      [
        " десять",
        " одиннадцать",
        " двенадцать",
        " тринадцать",
        " четырнадцать",
        " пятнадцать",
        " шестнадцать",
        " семнадцать",
        " восемнадцать",
        " девятнадцать",
      ],
      [
        "",
        "",
        " двадцать",
        " тридцать",
        " сорок",
        " пятьдесят",
        " шестьдесят",
        " семьдесят",
        " восемьдесят",
        " девяносто",
      ],
      [
        "",
        " сто",
        " двести",
        " триста",
        " четыреста",
        " пятьсот",
        " шестьсот",
        " семьсот",
        " восемьсот",
        " девятьсот",
      ],
      ["", " одна", " две"],
    ];
    return (
      e[3][k[0]] +
      (k[1] == 1 ? e[1][k[2]] : e[2][k[1]] + (d ? e[4][k[2]] : e[0][k[2]]))
    );
  }
  return i;
}
function declOfNum(n, t, o) {
  // склонение именительных рядом с числительным: число (typeof = string), корень (не пустой), окончание
  var k = [2, 0, 1, 1, 1, 2, 2, 2, 2, 2];
  return t == ""
    ? ""
    : " " + t + (n[n.length - 2] == "1" ? o[2] : o[k[n[n.length - 1]]]);
}
// function razUp(e) {
//   // сделать первую букву заглавной и убрать лишний первый пробел
//   return e[1].toUpperCase() + e.substring(2);
// }
window.money_letters = (a, currency) => {
  a = Number(a).toFixed(2).split(".");
  let r = "";
  switch (currency) {
    case 840:
      r =
        num_letters(a[0]) +
        declOfNum(a[0], "доллар", ["", "а", "ов"]) +
        " " +
        a[1] +
        declOfNum(a[1], "цент", ["", "ов", "ов"]);
      break;
    case 398:
      r =
        num_letters(a[0]) +
        declOfNum(a[0], "тенг", ["е", "е", "е"]) +
        " " +
        a[1] +
        declOfNum(a[1], "тиын", ["", "а", "ов"]);
      break;
    case 978:
      r =
        num_letters(a[0]) +
        declOfNum(a[0], "евр", ["о", "о", "о"]) +
        " " +
        a[1] +
        declOfNum(a[1], "цент", ["", "ов", "ов"]);
      break;
    case 156:
      r =
        num_letters(a[0]) +
        declOfNum(a[0], "яан", ["ь", "я", "ей"]) +
        " " +
        a[1] +
        declOfNum(a[1], "фєн", ["и", "я", "ей"]);
      break;
    default:
      r = num_letters(a[0]);
      break;
  }
  return r;
};

window.days_to_letters = (a) => {
  a = Number(a).toFixed(2).split(".");
  return num_letters(a[0]); // + declOfNum(a, '', ['день', 'дня', 'дней'])
};

window.percent_to_letters = (a) => {
  a = Number(a).toFixed(2).split(".");
  return num_letters(a[0]) + declOfNum(a[0], "процент", ["", "а", "ов"]);
};

window.number_to_letters = (a) => {
  a = Number(a[0]).toFixed(2).split(".");
  return num_letters(a);
};

function num_letters_en(k, d) {
  // целое число прописью, это основа
  var i = "",
    e = [
      [
        "",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion",
      ],
      ["", "s", "s"],
      ["", "s", "s"],
    ];
  if (typeof k == "object") k = k[0];

  if (k == "" || k == "0" || typeof k == "undefined" || isNaN(k))
    return " zero"; // 0
  k = k.split(/(?=(?:\d{3})+$)/); // разбить число в массив с трёхзначными числами
  if (k[0].length == 1) k[0] = "00" + k[0];
  if (k[0].length == 2) k[0] = "0" + k[0];
  for (var j = k.length - 1; j >= 0; j--) {
    // соединить трёхзначные числа в одно число, добавив названия разрядов с окончаниями
    if (k[j] != "000") {
      i =
        (((d && j == k.length - 1) || j == k.length - 2) &&
          (k[j][2] == "1" || k[j][2] == "2")
          ? t(k[j], 1)
          : t(k[j])) +
        declOfNum(
          k[j],
          e[0][k.length - 1 - j],
          j == k.length - 2 ? e[1] : e[2],
        ) +
        i;
    }
  }
  function t(k, d) {
    // преобразовать трёхзначные числа
    var e = [
      [
        "",
        " one",
        " two",
        " three",
        " four",
        " five",
        " siz",
        " seven",
        " eight",
        " nine",
      ],
      [
        " ten",
        " eleven",
        " twelve",
        " thirteen",
        " fourteen",
        " fifteen",
        " sixteen",
        " seventeen",
        " eighteen",
        " nineteen",
      ],
      [
        "",
        "",
        " twenty",
        " thirty",
        " fourty",
        " fifty",
        " sixty",
        " seventy",
        " eaighty",
        " ninety",
      ],
      [
        "",
        " hundreed",
        " two hundreed",
        " three hundreed",
        " four hundreed",
        " five hundreed",
        " six hundreed",
        " seven hundreed",
        " eight hundreed",
        " nine hundreed",
      ],
      ["", " one", " two"],
    ];
    return (
      e[3][k[0]] +
      (k[1] == 1 ? e[1][k[2]] : e[2][k[1]] + (d ? e[4][k[2]] : e[0][k[2]]))
    );
  }
  return i;
}
function declOfNum_en(n, t, o) {
  // склонение именительных рядом с числительным: число (typeof = string), корень (не пустой), окончание
  var k = [2, 0, 1, 1, 1, 2, 2, 2, 2, 2];
  return t == ""
    ? ""
    : " " + t + (n[n.length - 2] == "1" ? o[2] : o[k[n[n.length - 1]]]);
}
// function razUp_en(e) {
//   // сделать первую букву заглавной и убрать лишний первый пробел
//   return e[1].toUpperCase() + e.substring(2);
// }
window.money_letters_en = (a, currency) => {
  a = Number(a).toFixed(2).split(".");
  let r = "";
  switch (currency) {
    case 840:
      r =
        num_letters_en(a[0]) +
        declOfNum_en(a[0], "dollar", ["", "s", "s"]) +
        " " +
        a[1] +
        declOfNum(a[1], "cent", ["", "s", "s"]);
      break;
    case 398:
      r =
        num_letters_en(a[0]) +
        declOfNum_en(a[0], "tenge", ["", "", ""]) +
        " " +
        a[1] +
        declOfNum(a[1], "tiyn", ["", "s", "s"]);
      break;
    case 978:
      r =
        num_letters_en(a[0]) +
        declOfNum_en(a[0], "euro", ["", "s", "s"]) +
        " " +
        a[1] +
        declOfNum(a[1], "cent", ["", "s", "s"]);
      break;
    case 156:
      r =
        num_letters_en(a[0]) +
        declOfNum_en(a[0], "yan", ["", "s", "s"]) +
        " " +
        a[1] +
        declOfNum(a[1], "fan", ["", "s", "s"]);
      break;
    default:
      r = num_letters_en(a[0]);
      break;
  }
  return r;
};

window.days_to_letters_en = (a) => {
  a = Number(a).toFixed(2).split(".");
  return num_letters_en(a[0]); // + declOfNum(a, '', ['день', 'дня', 'дней'])
};

window.percent_to_letters_en = (a) => {
  a = Number(a).toFixed(2).split(".");
  return num_letters_en(a[0]) + declOfNum_en(a[0], "percent", ["", "s", "s"]);
};

window.number_to_letters_en = (a) => {
  a = Number(a[0]).toFixed(2).split(".");
  return num_letters_en(a);
};

//

//Components
/**
 * Separate design homepage
 */
// import HomepageIndex from "./components/homepage/index";
import HomepageNewIndex from "./components/newhomepage/index";
/**
 * EO Separate design homepage
 */

import Maintanance from "./components/maintanance.vue";

import Homepage from "./components/homepage.vue";
import TopBar from "./components/top-bar";
import BottomBar from "./components/bottom-bar";
import NewsItem from "./components/news/item";
import NewsSingle from "./components/news/single";
import SignUp from "./components/signin_singup/signup";
import SignUpFull from "./components/signin_singup/signup-full";
import SignIn from "./components/signin_singup/signin";
import SignInECP from "./components/signin_singup/signin-ecp";

import AML from "./components/aml";

import Validation from "./components/validation";

import ContentCMS from "./components/content";
import Contacts from "./components/contacts";
import FileList from "./components/files/file-list";
import FileSingle from "./components/files/file-single";
import FileNew from "./components/files/file-new";
import OfferSingle from "./components/contracts/offer-single";
import OfferNew from "./components/contracts/offer-new";
import ContractsContragentsSearch from "./components/contracts/contracts-contragents-search";
import ComplyAdvantageSearch from "./components/comply-advantage/comply-advantage-search";
import ComplyAdvantageCaseManagement from "./components/comply-advantage/comply-advantage-case-management";

import ContractsCouriersSearch from "./components/contracts/contractscourierssearch";
import ContractsBrokersSearch from "./components/contracts/contractsbrokerssearch";

import ContractsExim from "./components/contracts/contractsexim";
import BuyerSellerForm from "./components/contracts/buyer-seller-form";

import FormInvoice from "./components/contracts/form-invoice";
import FormCMR from "./components/contracts/form-cmr";
import FormFM1 from "./components/contracts/form-fm1";
import FormEpi from "./components/contracts/form-epi";
import FormAwb from "./components/contracts/form-awb";
import FormRwb from "./components/contracts/form-rwb";
import FormInsurance from "./components/contracts/form-insurance";
import FormLiabilityInsurance from "./components/contracts/form-liability-insurance";
import FormSad from "./components/contracts/form-sad";
import FormKtgAttorney from "./components/contracts/form-ktg-attorney";
import FormSpecification from "./components/contracts/form-specification";

import Findapartner_Index from "./components/find-a-partner/index";
import AllServicesCN from "./components/contracts/contragent-search/all-services-CN";
import CompanyInfoServiceCN from "./components/contracts/contragent-search/service-company-info-cn.vue";
import TmpCompanyInfoServiceCN from "./components/contracts/contragent-search/tmp-company-info.vue";

import OverallServiceCN from "./components/contracts/contragent-search/overall-service-cn.vue";
import OverallServiceCN410 from "./components/contracts/contragent-search/overall-service-cn-410.vue";
import OverallServiceCN410Admin from "./components/admin/overall-service-cn-410/overall-service-cn-410-admin.vue";
import OverallServiceCNBank from "./components/contracts/contragent-search/overall-service-cn-bank.vue";
import OverallServiceCNBankTestTranslate from "./components/contracts/contragent-search/overall-service-cn-bank-translate.vue";
import CNSearchHistory from "./components/contracts/contragent-search/history-page.vue";
import PersonSearchService from "./components/contracts/contragent-search/person-search-service/main.vue";
import RiskControlService from "./components/contracts/contragent-search/risk-control-service/main.vue";
import BusinessScoreService from "./components/contracts/contragent-search/business-score-service/main.vue";
import CaseFillingInfoService from "./components/contracts/contragent-search/case-filling-info-service/main.vue";
import AdminCompanyHistoricalSalesService from "./components/contracts/contragent-search/company-historical-sales-service/main.vue";

import AnnualReportCN from "./components/contracts/contragent-search/annual-report-cn-213.vue";
import TmpAnnualReportCN from "./components/contracts/contragent-search/tmp-annual-report.vue";

import EnterpriseRiskScanCN from "./components/contracts/contragent-search/enterprise-risk-scan-cn.vue";
import TmpEnterpriseRiskScanCN from "./components/contracts/contragent-search/tmp-risk-scan-cn.vue";
import TmpEnterpriseRiskScanCNFull from "./components/contracts/contragent-search/tmp-risk-scan-cn-full.vue";

import EnterpriseRiskScan736 from "./components/contracts/contragent-search/enterprise-risk-scan-736.vue";
import EnterpriseBasicInformation430 from "./components/contracts/contragent-search/enterprise-basic-information-430.vue";

import CompanyNewsServiceCN from "./components/contracts/contragent-search/company-news-service-cn";
import TmpCompanyNewsServiceCN from "./components/contracts/contragent-search/tmp-news-info-cn";

import CourtInfoServiceCN from "./components/contracts/contragent-search/court-service-cn.vue";
import TmpCourtInfoServiceCN from "./components/contracts/contragent-search/tmp-court-info.vue";
import EnterpriseFuzzyServiceCN from "./components/contracts/contragent-search/enterprise-fuzzy-search-cn.vue";
import EnterpriseFuzzyServiceCN410 from "./components/contracts/contragent-search/enterprise-fuzzy-search-cn-410.vue";

import GuestEducationIndex from "./components/education/education-guest.vue";
import EducationIndex from "./components/education/index.vue";
import EducationVideos from "./components/education/videos.vue";
import EducationManuals from "./components/education/manuals.vue";
import EducationExamples from "./components/education/examples.vue";

/** Search services helpers */
import SendEmail from "./components/contracts/contragent-search/helpers/send-email.vue";
import CACheck from "./components/contracts/contragent-search/helpers/ca-check.vue";
import HistorySaver from "./components/contracts/contragent-search/helpers/history-saver.vue";
import ContragentSearchHistory from "./components/contracts/contragent-search/helpers/history.vue";

import Contragents_Search_Index from "./components/contracts/contragent-search/index";
import ComplyAdvantage_Index from "./components/comply-advantage/index";
import Contracts_Index from "./components/contracts/index";
import Contracts_Add from "./components/contracts/add";
import Contracts_Single from "./components/contracts/single";
import Deals_Index from "./components/deals/index";
import Archive_Index from "./components/archive/index";

import AllOffers from "./components/account/offers";
import Account from "./components/account/account";
import NewAccount from "./components/account/newaccount";
import NewAccountFull from "./components/account/newaccount-full";

import AccountAuthHistory from "./components/account/account-auth-history";
import AccountOperationHistory from "./components/account/account-operation-history";
import AvatarEdit from "./components/account/avatar-edit";
import Avatar from "./components/account/avatar";
import Account_Edit from "./components/account/account-edit";
import Account_View from "./components/account/account-view";
import TopupAccount from "./components/account/topup";
import LoginSSO from "./components/account/sso";

import NotificationsTop from "./components/notifications/top";
import Notifications from "./components/notifications/main";

import FullScreen from "./components/full-screen";
import HelpSelector from "./components/help/help-selector";
import PDF from "./components/contracts/pdf-generation/pdf";
import JsPdf from "./components/contracts/pdf-generation/js-pdf";
import ProxyKtzh from "./components/contracts/pdf-generation/proxy-ktzh";
import PdfInvoice from "./components/contracts/pdf-generation/invoice";
import PdfSpecification from "./components/contracts/pdf-generation/specification";
import PdfCMR from "./components/contracts/pdf-generation/cmr";
import PdfContract from "./components/contracts/pdf-generation/contract";
import PdfTransportContract from "./components/contracts/pdf-generation/transport_contract";
import PdfBrokerContract from "./components/contracts/pdf-generation/broker_contract";
import PdfLiabilityInsurance from "./components/contracts/pdf-generation/liability_insurance";
import PdfInsurance from "./components/contracts/pdf-generation/insurance";
import PdfKtgAttorney from "./components/contracts/pdf-generation/ktg_attorney.vue";
import PdfAML from "./components/contracts/pdf-generation/aml";
import PdfAMLOverall from "./components/contracts/pdf-generation/aml-overall";
import PdfCompanyInfoCn from "./components/contracts/pdf-generation/company-info-cn.vue";
import PdfMainServiceCn from "./components/contracts/pdf-generation/main-service-cn.vue";
import PdfShortReferenceSearchCN from "./components/contracts/pdf-generation/short-reference-search-cn.vue";
import Pdf410 from "./components/contracts/pdf-generation/pdf-4-1-0.vue";
import PdfCourtInfoCn from "./components/contracts/pdf-generation/court-info-cn.vue";
import PdfNewsInfoCn from "./components/contracts/pdf-generation/news-info-cn.vue";

import PdfAnnualReportCn from "./components/contracts/pdf-generation/annual-report-cn.vue";
import PdfEnterpriseRiskScanCn from "./components/contracts/pdf-generation/enterprise-risk-scan-cn.vue";
import PdfEnterpriseRiskScanCnFull from "./components/contracts/pdf-generation/enterprise-risk-scan-cn-full.vue";
import PdfFormM from "./components/contracts/pdf-generation/form-m";

import PdfPacking from "./components/contracts/pdf-generation/packing";

import TwhIndex from "./components/twh/index";
import TwhNew from "./components/twh/new";
import TwhSingle from "./components/twh/single";

import DatePicker from "vue2-datepicker";

import "vue2-datepicker/index.css";

// import 'vue2-datepicker/locale/zh-cn';

import CodeValue from "./components/fields/code-value";
import Translatable from "./components/fields/translatable";
import VSelectEnhanced from "./components/fields/v-select-enhanced";
import VSelectPopup from "./components/fields/v-select-popup";
import AddressField from "./components/fields/address-field";
import FormSadSubitems from "./components/contracts/form-sad-subitems";
import SadProductField from "./components/fields/sad-product-field";
import SadTableField from "./components/fields/sad-table-field";

//admin
import AdminIndex from "./components/admin/index";
import AdminRegistrations from "./components/admin/registrations";
import AdminUsers from "./components/admin/users";
import AdminLogs from "./components/admin/logs";
import AdminOperations from "./components/admin/operations";
import AdminTOCOffers from "./components/admin/toc-offers";
import AdminCaHistory from "./components/admin/ca-history";
import AdminSADBuilder from "./components/admin/sad-builder";
import AdminNews from "./components/admin/news";
import AdminServicePrices from "./components/admin/serviceprices";
import AdminOperationsHistory from "./components/admin/admin-operations-history";
import AdminRequestsLog from "./components/admin/admin-requests-log";
import AdminRequestsLogApi from "./components/admin/admin-requests-log-api";
import AdminUserBalance from "./components/admin/admin-user-balance";
import AdminUsageReportUserHistory from "./components/admin/admin-usage-report-user-history";
import AdminTranslations from "./components/admin/translations";
//sad builder subitems
import SBRow from "./components/admin/sad-builder-elements/sad-builder-row";
import SBCol from "./components/admin/sad-builder-elements/sad-builder-col";
import SBElement from "./components/admin/sad-builder-elements/sad-builder-element";

//vendors
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import Cleave from "vue-cleave-component";
import vSelect from "vue-select";
import CheckboxDropdown from "./components/fields/checkbox-dropdown.vue";

import Logo from "./components/partials/logo.vue";
import LogoNigeria from "./components/partials/logo-nigeria.vue";
import CAFooterDocs from "./components/partials/ca-footer-docs.vue";
import CAFooterDocsEN from "./components/partials/ca-footer-docs-en.vue";
import FindPartnerDocs from "./components/partials/find-partner-docs.vue";
import FindPartnerDocsEN from "./components/partials/find-partner-docs-en.vue";
import BusinessNoteDocs from "./components/partials/business-note-docs.vue";
import BusinessNoteDocsEN from "./components/partials/business-note-docs-en.vue";

import SearchHelpText from "./components/search-help-text.vue";

import AnyJsonRenderer from "./components/any-json-renderer/main";

import { SignIn as NCSSignin, SignUp as NCSSignup } from './components/authorization-nigeria';

//separate homepage
// Vue.component("HomepageIndex", HomepageIndex);
//eo separate homepage
if (["full", "full-mac"].includes(process.env.VUE_APP_MODE)) {
  Vue.component("Logo", LogoNigeria);
} else {
  Vue.component("Logo", Logo);
}

Vue.component("CaFooterDocs", CAFooterDocs);
Vue.component("CaFooterDocsEn", CAFooterDocsEN);
Vue.component("FindPartnerDocs", FindPartnerDocs);
Vue.component("FindPartnerDocsEn", FindPartnerDocsEN);
Vue.component("BusinessNoteDocs", BusinessNoteDocs);
Vue.component("BusinessNoteDocsEn", BusinessNoteDocsEN);

Vue.component("Maintanance", Maintanance);

Vue.component("SbRow", SBRow);
Vue.component("SbCol", SBCol);
Vue.component("SbElement", SBElement);
Vue.component("Tippy", TippyComponent);

Vue.component("Datepicker", DatePicker);

Vue.component("AddressField", AddressField);
Vue.component("FormSadSubitems", FormSadSubitems);
Vue.component("SadProductField", SadProductField);
Vue.component("SadTableField", SadTableField);

Vue.component("Homepage", Homepage);
Vue.component("TopBar", TopBar);
Vue.component("BottomBar", BottomBar);
Vue.component("NewsItem", NewsItem);
Vue.component("NewsSingle", NewsSingle);
if (["full", "full-mac"].includes(process.env.VUE_APP_MODE)) {
  Vue.component("SignUp", NCSSignup);
  Vue.component("SignIn", NCSSignin);
} else {
  Vue.component("SignUp", SignUp);
  Vue.component("SignIn", SignIn);
}

Vue.component("SignInEcp", SignInECP);
Vue.component("Content", ContentCMS);
Vue.component("Contacts", Contacts);
Vue.component("FindAPartnerIndex", Findapartner_Index);
Vue.component("AllServicesCn", AllServicesCN);
Vue.component("CompanyInfoServiceCn", CompanyInfoServiceCN);
Vue.component("TmpCompanyInfoServiceCn", TmpCompanyInfoServiceCN);
Vue.component("OverallServiceCn", OverallServiceCN);
Vue.component("OverallServiceCn410", OverallServiceCN410);
Vue.component("OverallServiceCn410Admin", OverallServiceCN410Admin);
Vue.component("OverallServiceCnBank", OverallServiceCNBank);
Vue.component(
  "OverallServiceCnBankTranslate",
  OverallServiceCNBankTestTranslate,
);
Vue.component("PersonSearchService", PersonSearchService);
Vue.component("RiskControlService", RiskControlService);
Vue.component("BusinessScoreService", BusinessScoreService);
Vue.component("CaseFillingInfoService", CaseFillingInfoService);
Vue.component("AdminCompanyHistoricalSalesService", AdminCompanyHistoricalSalesService);

Vue.component("CnSearchHistory", CNSearchHistory);

Vue.component("EducationGuest", GuestEducationIndex);
Vue.component("EducationIndex", EducationIndex);
Vue.component("EducationVideos", EducationVideos);
Vue.component("EducationManuals", EducationManuals);
Vue.component("EducationExamples", EducationExamples);

Vue.component("AnnualReportServiceCn", AnnualReportCN);
Vue.component("TmpAnnualReportServiceCn", TmpAnnualReportCN);

Vue.component("EnterpriseRiskScanCn", EnterpriseRiskScanCN);
Vue.component("TmpRiskScanCn", TmpEnterpriseRiskScanCN);
Vue.component("TmpRiskScanCnFull", TmpEnterpriseRiskScanCNFull);

Vue.component("CompanyNewsServiceCn", CompanyNewsServiceCN);
Vue.component("TmpCompanyNewsServiceCn", TmpCompanyNewsServiceCN);

Vue.component("CourtInfoServiceCn", CourtInfoServiceCN);
Vue.component("TmpCourtInfoServiceCn", TmpCourtInfoServiceCN);
Vue.component("EnterpriseFuzzyServiceCn", EnterpriseFuzzyServiceCN);
Vue.component("EnterpriseFuzzyServiceCn410", EnterpriseFuzzyServiceCN410);

Vue.component("ContragentsSearchIndex", Contragents_Search_Index);

/** Search services helpers */
Vue.component("SendEmail", SendEmail);
Vue.component("CaCheck", CACheck);
Vue.component("HistorySaver", HistorySaver);
Vue.component("ContragentSeatchHistory", ContragentSearchHistory);

Vue.component("ComplyAdvantageIndex", ComplyAdvantage_Index);
Vue.component("ContractsIndex", Contracts_Index);
Vue.component("ContractsSingle", Contracts_Single);
Vue.component("ContractsAdd", Contracts_Add);
Vue.component("DealsIndex", Deals_Index);
Vue.component("ArchiveIndex", Archive_Index);
Vue.component("FileList", FileList);
Vue.component("FileSingle", FileSingle);
Vue.component("FileNew", FileNew);
Vue.component("OfferSingle", OfferSingle);
Vue.component("OfferNew", OfferNew);
Vue.component("ContractsContragentsSearch", ContractsContragentsSearch);
Vue.component("ComplyAdvantageSearch", ComplyAdvantageSearch);
Vue.component("ComplyAdvantageCaseManagement", ComplyAdvantageCaseManagement);
Vue.component("ContractsCouriersSearch", ContractsCouriersSearch);
Vue.component("ContractsBrokersSearch", ContractsBrokersSearch);

Vue.component("ContractsExim", ContractsExim);
Vue.component("BuyerSellerForm", BuyerSellerForm);
Vue.component("CodeValue", CodeValue);
Vue.component("Translatable", Translatable);

Vue.component("Navigation", Navigation);

Vue.component("Validation", Validation);

Vue.component("FormInvoice", FormInvoice);
Vue.component("FormCmr", FormCMR);
Vue.component("FormFm1", FormFM1);
Vue.component("FormEpi", FormEpi);
Vue.component("FormAwb", FormAwb);
Vue.component("FormRwb", FormRwb);
Vue.component("FormInsurance", FormInsurance);
Vue.component("FormLiabilityInsurance", FormLiabilityInsurance);
Vue.component("FormKtgAttorney", FormKtgAttorney);
Vue.component("FormSpecification", FormSpecification);

Vue.component("FormSad", FormSad);
// console.log(process.env.VUE_APP_MODE)
Vue.component("Account", Account);
if (["full", "full-mac"].includes(process.env.VUE_APP_MODE)) {
  Vue.component("Newaccount", NewAccountFull);
} else {
  Vue.component("Newaccount", NewAccount);
}
Vue.component("AccountAuthHistory", AccountAuthHistory);
Vue.component("AccountOperationHistory", AccountOperationHistory);
Vue.component("AccountEdit", Account_Edit);
Vue.component("AvatarEdit", AvatarEdit);
Vue.component("Avatar", Avatar);
Vue.component("AccountAllOffers", AllOffers);
Vue.component("TopupAccount", TopupAccount);
Vue.component("LoginSSO", LoginSSO);

Vue.component("NotificationsTop", NotificationsTop);
Vue.component("Notifications", Notifications);

Vue.component("FullScreen", FullScreen);
Vue.component("HelpSelector", HelpSelector);

/**
 * inputs
 */
Vue.component("VueBootstrapTypeahead", VueBootstrapTypeahead);
Vue.component("Cleave", Cleave);
Vue.component("VSelect", vSelect);
Vue.component("VSelectEnhanced", VSelectEnhanced);
Vue.component("VSelectPopup", VSelectPopup);
Vue.component("Tnved", tnved);
Vue.component("CheckboxDropdown", CheckboxDropdown);

Vue.component("Pdf", PDF);
Vue.component("JsPdf", JsPdf);
Vue.component("ProxyKtzh", ProxyKtzh);
Vue.component("PdfInvoice", PdfInvoice);
Vue.component("PdfSpecification", PdfSpecification);
Vue.component("PdfCmr", PdfCMR);
Vue.component("PdfContract", PdfContract);
Vue.component("PdfTransportContract", PdfTransportContract);
Vue.component("PdfBrokerContract", PdfBrokerContract);
Vue.component("PdfLiabilityInsurance", PdfLiabilityInsurance);
Vue.component("PdfInsurance", PdfInsurance);
Vue.component("PdfKtgAttorney", PdfKtgAttorney);
Vue.component("PdfAml", PdfAML);
Vue.component("PdfAmlOverall", PdfAMLOverall);
Vue.component("PdfCompanyInfoCn", PdfCompanyInfoCn);
Vue.component("PdfMainServiceCn", PdfMainServiceCn);
Vue.component("PdfShortReferenceSearchCn", PdfShortReferenceSearchCN);
Vue.component("Pdf410", Pdf410);

Vue.component("PdfCourtInfoCn", PdfCourtInfoCn);
Vue.component("PdfNewsInfoCn", PdfNewsInfoCn);

Vue.component("PdfAnnualReportCn", PdfAnnualReportCn);
Vue.component("PdfEnterpriseRiskScanCn", PdfEnterpriseRiskScanCn);
Vue.component("PdfEnterpriseRiskScanCnFull", PdfEnterpriseRiskScanCnFull);
Vue.component("PdfFormM", PdfFormM);

Vue.component("Aml", AML);
Vue.component("PdfPacking", PdfPacking);

Vue.component("AdminIndex", AdminIndex);
Vue.component("AdminRegistrations", AdminRegistrations);
Vue.component("AdminUsers", AdminUsers);
Vue.component("AdminLogs", AdminLogs);
Vue.component("AdminOperations", AdminOperations);
Vue.component("AdminTocOffers", AdminTOCOffers);
Vue.component("AdminCaHistory", AdminCaHistory);
Vue.component("AdminSadBuilder", AdminSADBuilder);
Vue.component("AdminNews", AdminNews);
Vue.component("AdminServiceprices", AdminServicePrices);
Vue.component("AdminOperationsHistory", AdminOperationsHistory);
Vue.component("AdminRequestsLog", AdminRequestsLog);
Vue.component("AdminRequestsLogApi", AdminRequestsLogApi);
Vue.component("AdminUserBalance", AdminUserBalance);
Vue.component("AdminUsageReportUserHistory", AdminUsageReportUserHistory);
Vue.component("AdminTranslations", AdminTranslations);

Vue.component("TwhIndex", TwhIndex);
Vue.component("TwhNew", TwhNew);
Vue.component("TwhSingle", TwhSingle);

Vue.component("SearchHelpText", SearchHelpText);

Vue.component("AnyJsonRenderer", AnyJsonRenderer);

window._token = "123456789";

// window.ymapsInit = function(){
// 	window.customer_address_s = new ymaps.SuggestView('customer_address')
// 	window.company_address_s = new ymaps.SuggestView('company_address')
// }

//Locales
import messages from "./i18n/locale";
import { type } from "jquery";

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(VueTippy);

var locale = window.location.pathname.replace(/^\/([^\/]+).*/i, "$1");
let locale_fallback = "ru";
if (window.location.hostname == "attistrade.cn") {
  locale_fallback = "cn";
}
if (["full", "full-mac"].includes(process.env.VUE_APP_MODE)) {
  locale = 'en'
}

var yandexLocale =
  "https://api-maps.yandex.ru/2.1/?lang=en_RU&apikey=2cabfb16-6713-4bbd-b1f4-a203861a4ce4";
if (locale.trim().length && locale == "ru") {
  yandexLocale =
    "https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=2cabfb16-6713-4bbd-b1f4-a203861a4ce4";
}

$S(yandexLocale);
// if (locale == "uk") locale = "ru";
// if (locale === "/") locale = navigator.language.split("-")[0];
// console.log(locale)
const router = new VueRouter({
  base:
    locale.trim().length && locale != "/"
      ? "/" + locale
      : "/" + locale_fallback,
  routes: [
    {
      path: "/",
      component: HomepageNewIndex,
      name: "homepage-index",
    },
    // {
    //   path: "/new/",
    //   component: HomepageNewIndex,
    //   name: "homepagenew-index",
    // },
    {
      path: "/app/",
      component: Homepage,
      name: "home",
    },
    {
      path: "/app/success",
      component: Homepage,
      name: "home-after-reg",
    },
    {
      path: "/app/authed",
      component: Homepage,
      name: "home-after-login",
    },
    //education
    {
      path: "/education",
      component: GuestEducationIndex,
      name: "education-guest",
    },
    {
      path: "/app/education",
      component: EducationIndex,
      name: "education-index",
    },
    {
      path: "/app/education/videos",
      component: EducationIndex,
      name: "education-videos",
    },
    {
      path: "/app/education/videos/:hash",
      component: EducationIndex,
      name: "education-videos-single",
    },
    {
      path: "/app/education/manuals",
      component: EducationIndex,
      name: "education-manuals",
    },
    {
      path: "/app/education/manuals/:hash",
      component: EducationIndex,
      name: "education-manuals-single",
    },
    {
      path: "/app/education/examples",
      component: EducationIndex,
      name: "education-examples",
    },
    {
      path: "/app/education/examples/:hash",
      component: EducationIndex,
      name: "education-examples-single",
    },
    {
      path: "/app/education/links",
      component: EducationIndex,
      name: "education-links",
    },
    {
      path: "/app/education/links/:hash",
      component: EducationIndex,
      name: "education-links-single",
    },
    //aml
    {
      path: "/app/aml/:id",
      component: AML,
      name: "aml",
    },
    //sing in / sing up
    {
      path: "/app/sign-up",
      component: ["full", "full-mac"].includes(process.env.VUE_APP_MODE)
        ? NCSSignup
        : SignUp,
      name: "sign-up",
    },
    // {
    //   path: "/sign-in",
    //   redirect: { name: "sign-in" },
    // },
    {
      path: "/app/sign-in/expired",
      component: ["full", "full-mac"].includes(process.env.VUE_APP_MODE) ? NCSSignin : SignIn,
      name: "pwd-expired",
    },
    {
      path: "/app/sign-in/email-confirmed",
      component: ["full", "full-mac"].includes(process.env.VUE_APP_MODE) ? NCSSignin : SignIn,
      name: "email-confirmed",
    },
    {
      path: "/app/sign-in",
      component: ["full", "full-mac"].includes(process.env.VUE_APP_MODE) ? NCSSignin : SignIn,
      name: "sign-in",
    },
    {
      path: "/reset/:code",
      component: SignIn,
      name: "sign-in-reset",
    },
    {
      path: "/app/sign-in-ecp",
      component: SignInECP,
      name: "sign-in-ecp",
    },
    {
      path: "/login-sso",
      component: LoginSSO,
      name: "login-sso",
    },
    //content
    {
      path: "/app/about",
      component: ContentCMS,
      name: "content-about",
    },
    {
      path: "/app/project",
      component: ContentCMS,
      name: "content-project",
    },
    {
      path: "/app/management",
      component: ContentCMS,
      name: "content-management",
    },
    {
      path: "/app/contacts",
      component: Contacts,
      name: "contacts",
    },
    //news
    {
      path: "/app/news",
      name: "news",
    },
    {
      path: "/app/news/:item",
      component: NewsSingle,
      name: "news-single",
    },
    //authed functions
    {
      path: "/app/find-a-partner",
      component: Findapartner_Index,
      name: "find-a-partner-index",
    },
    {
      path: "/app/all-services-cn",
      component: AllServicesCN,
      name: "all-services-cn",
    },
    {
      path: "/app/company-info-service-cn",
      component: CompanyInfoServiceCN,
      name: "company-info-service-cn",
    },
    {
      path: "/app/overall-service-cn",
      component: OverallServiceCN,
      name: "overall-service-cn",
    },
    {
      path: "/app/person-search-service",
      component: PersonSearchService,
      name: "person-search-service",
    },
    {
      path: "/app/risk-control-service",
      component: RiskControlService,
      name: "risk-control-service",
    },
    {
      path: "/app/find-partner-info",
      component: OverallServiceCN,
      name: "find-partner-info",
    },
    {
      path: "/app/find-partner-info-advanced",
      component: OverallServiceCN410,
      name: "find-partner-410",
    },
    {
      path: "/app/business-note",
      component: OverallServiceCNBank,
      name: "business-note",
    },
    {
      path: "/app/business-note-translate",
      component: OverallServiceCNBankTestTranslate,
      name: "business-note-translate",
    },

    {
      path: "/app/find-partner-info-history",
      component: OverallServiceCN,
      name: "find-partner-info-hist-tab",
    },
    {
      path: "/app/find-partner-advanced-history",
      component: OverallServiceCN410,
      name: "find-partner-410-hist-tab",
    },

    {
      path: "/app/business-note-history",
      component: OverallServiceCNBank,
      name: "business-note-hist-tab",
    },
    {
      path: "/app/find-partner-info-history/single",
      component: OverallServiceCN,
      name: "cs-single",
    },
    {
      path: "/app/find-partner-advanced-history/single",
      component: OverallServiceCN410,
      name: "cs-410-single",
    },
    {
      path: "/app/business-note-history/single",
      component: OverallServiceCNBank,
      name: "bn-single",
    },

    {
      path: "/app/search-history",
      component: CNSearchHistory,
      name: "cn-search-history",
    },
    {
      path: "/app/search-history-note",
      component: CNSearchHistory,
      name: "cn-search-history-note",
    },
    {
      path: "/app/annual-report-service-cn",
      component: AnnualReportCN,
      name: "annual-report-service-cn",
    },
    {
      path: "/app/enterprise-risk-scan",
      component: EnterpriseRiskScan736,
      name: "enterprise-risk-scan",
    },
    {
      path: "/app/enterprise-basic-information",
      component: EnterpriseBasicInformation430,
      name: "enterprise-basic-information",
    },
    {
      path: "/app/enterprise-risk-scan-cn",
      component: EnterpriseRiskScanCN,
      name: "enterprise-risk-scan-cn",
    },
    {
      path: "/app/company-news-service-cn",
      component: CompanyNewsServiceCN,
      name: "company-news-service-cn",
    },
    {
      path: "/app/contragents-search",
      component: Contragents_Search_Index,
      name: "contragents-search-index",
    },
    {
      path: "/app/comply-advantage/",
      component: ComplyAdvantage_Index,
      name: "comply-advantage-index",
    },
    {
      path: "/app/comply-advantage/history",
      component: ComplyAdvantage_Index,
      name: "comply-advantage-history",
    },
    {
      path: "/app/comply-advantage/history/single",
      component: ComplyAdvantage_Index,
      name: "ca-single",
    },

    {
      path: "/app/find-a-partner/result",
      component: Findapartner_Index,
      name: "find-a-partner-result",
    },
    {
      path: "/app/find-a-partner/:id",
      component: Findapartner_Index,
      name: "find-a-partner-single",
    },
    {
      path: "/app/contracts/view/:id",
      component: Contracts_Single,
      name: "contracts-single",
    },
    {
      path: "/app/contracts/view/:id/offers",
      component: Contracts_Single,
      name: "contracts-single-offers-tab",
    },
    {
      path: "/app/contracts/view/:id/couriers",
      component: Contracts_Single,
      name: "contracts-single-couriers-tab",
    },
    {
      path: "/app/contracts/view/:id/brokers",
      component: Contracts_Single,
      name: "contracts-single-brokers-tab",
    },
    {
      path: "/app/contracts/view/:id/documents",
      component: Contracts_Single,
      name: "contracts-single-documents-tab",
    },
    {
      path: "/app/contracts/view/:id/signed",
      component: Contracts_Single,
      name: "contracts-single-signed",
    },
    {
      path: "/app/contracts/view/:id/offer/:oid",
      component: Contracts_Single,
      name: "offer-single",
    },
    {
      path: "/app/contracts/view/:id/courier/:oid",
      component: Contracts_Single,
      name: "courier-single",
    },
    {
      path: "/app/contracts/view/:id/broker/:oid",
      component: Contracts_Single,
      name: "broker-single",
    },
    {
      path: "/app/contracts",
      component: Contracts_Index,
      name: "contracts-index",
    },
    {
      path: "/app/contracts/success",
      component: Contracts_Index,
      name: "contracts-index-just-added",
    },
    {
      path: "/app/my-contracts",
      component: Contracts_Index,
      name: "contracts-mine",
    },
    {
      path: "/app/contracts/create",
      component: Contracts_Add,
      name: "contracts-add",
    },

    {
      path: "/app/deals",
      component: Deals_Index,
      name: "deals-index",
    },
    {
      path: "/app/deals/view/:id",
      component: Contracts_Single,
      name: "deals-single",
    },
    {
      path: "/app/archive",
      component: Archive_Index,
      name: "archive-index",
    },
    //account
    {
      path: "/app/account",
      component: ["full", "full-mac"].includes(process.env.VUE_APP_MODE)
        ? NewAccountFull
        : NewAccount,
      name: "account",
    },
    {
      path: "/app/newaccount",
      component: NewAccount,
      name: "newaccount",
    },
    {
      path: "/app/account/history",
      component: AccountAuthHistory,
      name: "account-auth-history",
    },
    {
      path: "/app/account/operation-history",
      component: AccountOperationHistory,
      name: "account-operation-history",
    },
    {
      path: "/app/account-edit",
      component: Account_Edit,
      name: "account-edit",
    },
    {
      path: "/app/profile/:id",
      component: Account_View,
      name: "user-profile",
    },
    {
      path: "/app/profile/:id/personal",
      component: Account_View,
      name: "user-profile-personal",
    },
    {
      path: "/app/profile/:id/company",
      component: Account_View,
      name: "user-profile-company",
    },
    {
      path: "/app/account/insurance-request/:id",
      component: Account,
      name: "view-insurance-request",
    },
    {
      path: "/app/account/balance-request/",
      component: NewAccount, //TopupAccount,
      name: "topup-account",
    },
    {
      path: "/app/account/balance-request/history",
      component: TopupAccount,
      name: "topup-account-history",
    },
    //notifications
    {
      path: "/app/notifications",
      component: Notifications,
      name: "notifications",
    },
    //admin
    {
      path: "/app/admin",
      component: AdminIndex,
      name: "admin-index",
    },
    {
      path: "/app/admin/registrations",
      component: AdminRegistrations,
      name: "admin-registrations",
    },
    {
      path: "/app/admin/users",
      component: AdminUsers,
      name: "admin-users",
    },
    {
      path: "/app/admin/logs",
      component: AdminLogs,
      name: "admin-logs",
    },
    {
      path: "/app/admin/operations",
      component: AdminOperations,
      name: "admin-operations",
    },
    {
      path: "/app/admin/toc-offers",
      component: AdminTOCOffers,
      name: "admin-toc-offers",
    },
    {
      path: "/app/admin/ca-history",
      component: AdminCaHistory,
      name: "admin-ca-history",
    },

    {
      path: "/app/admin/sad-builder",
      component: AdminSADBuilder,
      name: "admin-sad-builder",
    },
    {
      path: "/app/admin/news",
      component: AdminNews,
      name: "admin-news",
    },
    {
      path: "/app/admin/prices",
      component: AdminServicePrices,
      name: "admin-service-prices",
    },
    {
      path: "/app/admin/user-operations",
      component: AdminOperationsHistory,
      name: "admin-operations-history",
    },
    {
      path: "/app/admin/requests-log",
      component: AdminRequestsLog,
      name: "admin-requests-log",
    },
    {
      path: "/app/admin/requests-log-api",
      component: AdminRequestsLogApi,
      name: "admin-requests-log-api",
    },
    {
      path: "/app/admin/user-balance",
      component: AdminUserBalance,
      name: "admin-user-balance",
    },
    {
      path: "/app/admin/admin-usage-report-user-history",
      component: AdminUsageReportUserHistory,
      name: "admin-usage-report-user-history",
    },
    {
      path: "/app/admin/translations",
      component: AdminTranslations,
      name: "admin-translations",
    },
    {
      path: "/app/admin/find-partner-info-advanced",
      component: OverallServiceCN410Admin,
      name: "find-partner-410-admin",
    },
    {
      path: "/app/admin/business-score-service",
      component: BusinessScoreService,
      name: "admin-business-score-service",
    },
    {
      path: "/app/business-score-service",
      component: BusinessScoreService,
      name: "business-score-service",
    },
    {
      path: "/app/admin/case-filling-info-service",
      component: CaseFillingInfoService,
      name: "admin-case-filling-info-service",
    },
    {
      path: "/app/case-filling-info-service",
      component: CaseFillingInfoService,
      name: "case-filling-info-service",
    },
    {
      path: "/app/admin-company-historical-sales-service",
      component: AdminCompanyHistoricalSalesService,
      name: "admin-company-historical-sales-service",
    },
    //TWH
    {
      path: "/app/twh",
      component: TwhIndex,
      name: "twh-index",
    },
    {
      path: "/app/twh/new",
      component: TwhNew,
      name: "twh-new",
    },
    {
      path: "/twh/view/:id",
      component: TwhSingle,
      name: "twh-single",
    },
    ...routes_external
  ],
});

window.is_searched = false;
window.is_exit_popup = false;

router.beforeEach((to, from, next) => {
  if ((to.name == "sign-in" || to.name == "sign-up") && store.state.auth)
    next({ name: "home" });
  if (
    to.name !== "sign-in" &&
    to.name !== "sign-up" &&
    to.name !== "homepage-index" &&
    to.name !== "education-guest" &&
    to.name !== "sign-in-reset" &&
    to.name !== "documentation" &&
    to.name !== 'login-sso' &&
    !store.state.auth
  )
    next({ name: "sign-in" });

  if (
    [
      "find-a-partner-index",
      "all-services-cn",
      "company-info-service-cn",
      "overall-service-cn",
      "annual-report-service-cn",
      "enterprise-risk-scan-cn",
      "company-news-service-cn",
      "contragents-search-index",
      "comply-advantage-index",
      "find-a-partner-result",
      "find-a-partner-single",
      "business-note",
      "find-partner-info",
      "cn-search-history",
    ].includes(from.name) &&
    ![
      "find-a-partner-index",
      "all-services-cn",
      "company-info-service-cn",
      "overall-service-cn",
      "annual-report-service-cn",
      "enterprise-risk-scan-cn",
      "company-news-service-cn",
      "contragents-search-index",
      "comply-advantage-index",
      "find-a-partner-result",
      "find-a-partner-single",
      "business-note",
      "find-partner-info",
      "cn-search-history",
    ].includes(to.name) &&
    window.is_searched
  ) {
    if (!window.is_exit_popup) {
      window.is_exit_popup = true;
      window.vue.$bvModal
        .msgBoxConfirm(
          window.vue.$t("message.find_partner.confirm_move_to_other_page"),
          {
            title: window.vue.$t("message.confirm"),
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: window.vue.$t("message.yes"),
            cancelTitle: window.vue.$t("message.no"),
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          },
        )
        .then((value) => {
          if (value) {
            window.is_searched = false;
            window.is_exit_popup = false;
            next();
          } else {
            window.is_exit_popup = false;
          }
        });
    }
  } else next();
});

// let entryLocale = "en";
// if(window.location.hostname=='attistrade.cn') {
//   entryLocale = "cn";
// }

const i18n = new VueI18n({
  locale:
    locale.trim().length && locale != "/"
      ? locale
      : window.location.hostname == "attistrade.cn"
        ? "cn"
        : "ru",
  fallbackLocale: "ru",
  messages, // set locale messages
});

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    auth: false,
    user: {},
    expand: false,
    firmfull: false,
    isDemoMode: false,
  },
  mutations: {
    login(state, payload) {
      state.auth = true;
      state.user = payload.user;
    },
    logout(state) {
      state.auth = false;
      state.user = {};
      state.firmfull = false;
    },
    expand(state, payload) {
      state.expand = payload;
    },
    load_firm(state, payload) {
      state.firmfull = payload;
    },
    update_firm_person(state, payload) {
      state.firmfull.persons = payload;
    },
    update_firm_company(state, payload) {
      state.firmfull.organizations = payload;
    },
    update_firm_socials(state, payload) {
      state.firmfull.socials = payload;
    },
    update_firm_person_socials(state, payload) {
      state.firmfull.person_social = payload;
    },
    update_firm_banks(state, payload) {
      state.firmfull.banks = payload;
    },
    update_firm_addresses(state, payload) {
      state.firmfull.addresses = payload;
    },
    show_navigation(state, payload) {
      state.show_navigation = payload;
    },
    show_kyc_message(state, payload) {
      state.show_kyc_message = payload;
    },
    toggleDemoMode(state) {
      state.isDemoMode = !state.isDemoMode;
    },
  },
});

Vue.config.productionTip = false;

window.vue = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// console.log(vue)

jQuery(function ($) {
  $(".navbar-toggler").click(function () {
    $("html").toggleClass("nav-open");
    $(".nav-link").click(function () {
      $("html").toggleClass("nav-open");
    });
  });
});

window.getKeyInfoBack = function (result) {
  if (result["code"] === "200") {
    var res = result["responseObject"];
    //var dateString = res["certNotAfter"];
    //var date = new Date(Number(dateString));
    var bodyFormData = new FormData();
    // bodyFormData.set("data", date.toLocaleString());
    // bodyFormData.set("guid", res["subjectDn"]);
    //bodyFormData.set("cert", res["pem"]);
    bodyFormData.append("cert", res["pem"]);
    axios({
      method: "post",
      url: window.base + "/Account/EcpLogin/",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" },
    }).then((response) => {
      if (response.data.statusCode == 200) {
        let user_object = response.data.user;
        user_object.Roles = JSON.parse(user_object.Roles);
        vue.$store.commit("login", {
          user: user_object, //JSON.parse(response.data.user.replace('"user": ', "")),
        });
        vue.$router.push({ name: "home" });
      } else {
        var errorMessage = "";
        switch (response.data.statusMessage) {
          case "InvalidEDS":
            errorMessage = i18n.t("message.message.login_ecp_invalid");
            break;
          case "UserNotFound":
            errorMessage = i18n.t("message.message.login_user_not_found");
            break;
        }
        new Noty({
          theme: "light",
          type: "error",
          text: errorMessage,
          timeout: 5000,
        }).show();
      }
    });

    // axios.post(window.base+"/Account/EcpLogin/", {
    // 	data: date.toLocaleString(),
    // 	guid: res['subjectDn']
    // }).then(response=>{
    // 	if(response.data.statusCode==200){
    // 		this.$store.commit('login', {user: response.data.user})
    // 		this.$router.push({name: 'home'})
    // 	}
    // })
    // $.ajax({
    // url: "/Account/EcpLogin/",
    // type: "POST",
    // data: {
    // data: date.toLocaleString(),
    // guid: res['subjectDn']
    // }
    // }).done(function (data) {
    // 	window.location.href = data
    // });
  } else alert(result["message"]);
};

window.Base64 = {
  // private property
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

  // public method for encoding
  encode: function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = window.Base64._utf8_encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output =
        output +
        this._keyStr.charAt(enc1) +
        this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) +
        this._keyStr.charAt(enc4);
    }
    return output;
  },

  // public method for decoding
  decode: function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = window.Base64._utf8_decode(output);

    return output;
  },

  // private method for UTF-8 encoding
  _utf8_encode: function (string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  },

  // private method for UTF-8 decoding
  _utf8_decode: function (utftext) {
    var string = "";
    var i = 0;
    var c = (c1 = c2 = 0);

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode(
          ((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63),
        );
        i += 3;
      }
    }
    return string;
  },
};

window.rubFormat = (amount, currency = "RUB") => {
  let locale = "ru-RU";
  switch (i18n.locale) {
    case "ru":
      locale = "ru-RU";
      break;
    case "en":
      locale = "en-US";
      break;
    case "cn":
      locale = "zh-CN";
      break;
    default:
      locale = "ru-RU";
  }
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency,

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(amount);
};
